import breakpoints from './breakpoints';

export default {
  'break-2': window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`),
  'break-3': window.matchMedia(`(min-width: ${breakpoints['break-3']}px)`),
  'break-4': window.matchMedia(`(min-width: ${breakpoints['break-4']}px)`),
};
